import Vue from 'vue';
import VueRouter, { createRouter, createWebHashHistory } from 'vue-router';
import { mystore } from '@/store';
import routes from './routes';
import loginRoutes from './login-routes';
import { getAllPreferences } from '@/appLogic/preferenceManage';
import { app } from '@/main';
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */

// app.use(VueRouter);
const router = createRouter({
  history: createWebHashHistory(),
  routes: [...routes, ...loginRoutes],
  linkExactActiveClass: 'nav-item active',
});

router.beforeEach((to, _from, next) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (to.name === 'login') {
    next();
  } else {
    if (requiresAuth) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (mystore.getters['loginStateModule/authenticated']) {
        getAllPreferences(mystore.getters['loginStateModule/email']);
        next();
      } else {
        next({ name: 'login' });
      }
    } else {
      next();
    }
  }
});

export default router;
export const myrouter = router;
